import gql from "graphql-tag";

export const EDIT_EVENT = gql`
  mutation update_events_by_pk(
    $id: uuid!
    $categories: String
    $cover_photo: String
    $cover_photo_path: String
    $date_time: timestamptz
    $end_date: timestamptz
    $description: String
    $end_date_time: timestamp
    $event_payment_type: String
    $is_all_day: Boolean
    $location: geometry
    $location_text: String
    $name: String
    $start_date_time: timestamp
    $total_attendees: Int
    $external_ticket_url: String
    $is_ticket_required: Boolean
  ) {
    update_events_by_pk(
      pk_columns: { id: $id }
      _set: {
        name: $name
        date_time: $date_time
        end_date: $end_date
        is_ticket_required: $is_ticket_required
        description: $description
        event_payment_type: $event_payment_type
        total_attendees: $total_attendees
        categories: $categories
        cover_photo: $cover_photo
        cover_photo_path: $cover_photo_path
        end_date_time: $end_date_time
        is_all_day: $is_all_day
        location: $location
        location_text: $location_text
        start_date_time: $start_date_time
        external_ticket_url: $external_ticket_url
      }
    ) {
      id
    }
  }
`;
